export const PAGE_EVENTS = {
  REGISTRATION_WELCOME: 'Registration_Welcome',
  REGISTRATION_SIGN_IN: 'Registration_Sign_In',
  REGISTRATION_PASSWORD_SETUP: 'Registration_Password_Setup',
  REGISTRATION_BUSINESS_CATEGORY: 'Registration_Business_Category',
  REGISTRATION_ABOUT_YOU: 'Registration_About_You',
  REGISTRATION_WHERE_DO_YOU_WORK: 'Registration_Where_Do_You_Work',
  REGISTRATION_YOUR_ADDRESS: 'Registration_Your_Address',
  REGISTRATION_ENTER_ADDRESS: 'Registration_Enter_Address',
  REGISTRATION_CONFIRM_ADDRESS: 'Registration_Confirm_Address',
  REGISTRATION_CONFIRM_LOCATION_PIN: 'Registration_Confirm_Location_Pin',
  REGISTRATION_BUSINESS_HOURS: 'Registration_Business_Hours',
  REGISTRATION_ADDING_SERVICES: 'Registration_Adding_Services',
  REGISTRATION_ADD_SERVICE: 'Registration_Add_Service',
  REGISTRATION_SURVEY_TEAM_SIZE: 'Registration_Survey_Team_Size',
  REGISTRATION_SURVEY_GOALS: 'Registration_Survey_Goals',
  REGISTRATION_SURVEY_BOOKING_ADVANCE: 'Registration_Survey_Booking_Advance',
  REGISTRATION_SURVEY_BUSINESS_FOCUS: 'Registration_Survey_Business_Focus',
  REGISTRATION_SURVEY_PREVIOUSLY_USED_TOOLS:
    'Registration_Survey_Previously_Used_Tools',
  REGISTRATION_CONGRATULATIONS: 'Registration_Congratulations',
  REGISTRATION_SURVEY_APPOINTMENTS: 'Registration_Survey_Appointments',
  SUBSCRIPTION_TRIAL_EXPIRED: 'Subscription_Trial_Expired',
  SUBSCRIPTION_TRIAL_EXPIRED_MOBILE_MANAGEMENT_NEEDED:
    'Subscription_Trial_Expired_Mobile_Management_Needed',
  SUBSCRIPTION_OFFER: 'Subscription_Offer',
  SUBSCRIPTION_UNABLE_TO_MANAGE: 'Subscription_Unable_To_Manage',
  SUBSCRIPTION_PAYMENT_DETAILS: 'Subscription_Payment_Details',
  SUBSCRIPTION_PAYMENT_FAILED: 'Subscription_Payment_Failed',
  SUBSCRIPTION_PAYMENT_SUCCESSFUL: 'Subscription_Payment_Successful',
  SUBSCRIPTION_YOUR_SUBSCRIPTION: 'Subscription_Your_Subscription',
  SHARE_PROFILE: 'Share_Profile',
  PROFILE_QR_CODE: 'Profile_QR_Code',
  EDIT_PROFILE: 'Edit_Profile',
  JUMPSTART_CHALLENGE: 'Jumpstart_Challenge',
  STAFF_MANAGEMENT_MEMBERS_LIST: 'Staff_Management_Members_List',
  EDIT_STAFF_MEMBER: 'Edit_Staff_Member',
  ADD_STAFF_MEMBER: 'Add_Staff_Member',
  STAFF_MEMBER_ROLE_AND_PERMISSIONS: 'Staff_Member_Role_And_Permissions',
  STAFF_MEMBER_CUSTOMIZE_PERMISSIONS: 'Staff_Member_Customize_Permissions',
  REMOVE_STAFF_MEMBER: 'Remove_Staff_Member',
  REMOVE_STAFF_MEMBER_AND_SERVICES: 'Remove_Staff_Member_And_Services',
  REMOVE_STAFF_MEMBER_ONLINE_BOOKING_WILL_BE_DISABLED:
    'Remove_Staff_Member_Online_Booking_Will_Be_Disabled',
  REMOVE_STAFF_MEMBER_UNABLE_TO_MAKE_THE_CHANGE:
    'Remove_Staff_Member_Unable_To_Make_The_Change',
  REMOVE_STAFF_MEMBER_REASSIGN_UPCOMING_APPOINTMENTS:
    'Remove_Staff_Member_Reassign_Upcoming_Appointments',
  REMOVE_STAFF_MEMBER_REASSIGN_APPOINTMENTS:
    'Remove_Staff_Member_Reassign_Appointments',
  REMOVE_STAFF_MEMBER_ALL_APPOINTMENTS_REASSIGNED:
    'Remove_Staff_Member_All_Appointments_Reassigned',
  JUMPSTART_BANNER: 'Jumpstart_Banner',
  JUMPSTART_MORE_DETAILS: 'Jumpstart_More_Details',
  JUMPSTART_CHALLENGE_CONGRATULATIONS: 'Jumpstart_Challenge_Congratulations',
} as const

export const TRACK_EVENTS = {
  REGISTRATION_STARTED: 'Registration_Started',
  REGISTRATION_COMPLETED: 'Registration_Completed',
  EXPERIMENT_VIEWED: 'Experiment_Viewed',
  SUBSCRIPTION_OFFER_SUBSCRIBE_BUTTON_CLICKED:
    'Subscription_Offer_Subscribe_Button_Clicked',
  SUBSCRIPTION_PAYMENT_DETAILS_SUBSCRIBE_BUTTON_CLICKED:
    'Subscription_Payment_Details_Subscribe_Button_Clicked',
  SUBSCRIPTION_ACTIVATED: 'Subscription_Activated',
  SUBSCRIPTION_PAYMENT_FAILED: 'Subscription_Payment_Failed',
  SUBSCRIPTION_PAYMENT_FAILED_TRY_AGAIN_BUTTON_CLICKED:
    'Subscription_Payment_Failed_Try_Again_Button_Clicked',
  EDIT_PROFILE_BACK_CLICKED: 'Edit_Profile_Back_Clicked',
  EDIT_PROFILE_SERVICES_CLICKED: 'Edit_Profile_Services_Clicked',
  EDIT_PROFILE_IMAGES_CLICKED: 'Edit_Profile_Images_Clicked',
  EDIT_PROFILE_INFO_CLICKED: 'Edit_Profile_Info_Clicked',
  EDIT_PROFILE_LOCATION_CLICKED: 'Edit_Profile_Location_Clicked',
  EDIT_PROFILE_HOURS_CLICKED: 'Edit_Profile_Hours_Clicked',
  EDIT_PROFILE_BOOKING_CLICKED: 'Edit_Profile_Booking_Clicked',
  SHARE_YOUR_PROFILE_LINK_BUTTON_CLICKED:
    'Share_Your_Profile_Link_Button_Clicked',
  IMPORT_AND_INVITE_CLIENTS_BUTTON_CLICKED:
    'Import_And_Invite_Clients_Button_Clicked',
  JUMPSTART_CHALLENGE_PROGRESS_DISPLAYED:
    'Jumpstart_Challenge_Progress_Displayed',
  REMOVE_STAFF_MEMBER_BUTTON_CLICKED: 'Remove_Staff_Member_Button_Clicked',
  REMOVE_STAFF_MEMBER_DELETED_CONFIRMATION_DISPLAYED:
    'Remove_Staff_Member_Deleted_Confirmation_Displayed',
  STAFF_MEMBER_PERMISSION_LEVEL_CLICKED: 'Staff_Member_Permission_Level_Clicked',
  STAFF_MEMBER_ROLE_WITH_PERMISSIONS_SELECTED:
    'Staff_Member_Role_With_Permissions_Selected',
  STAFF_MEMBER_CUSTOMIZE_PERMISSIONS_FORM_SUBMITTED:
    'Staff_Member_Customize_Permissions_Form_Submitted',
  EDIT_STAFF_MEMBER_SAVE_BUTTON_CLICKED: 'Edit_Staff_Member_Save_Button_Clicked',
  ADD_STAFF_MEMBER_SAVE_BUTTON_CLICKED: 'Add_Staff_Member_Save_Button_Clicked',
  STAFF_MEMBER_EDIT_CONFIRMATION_DISPLAYED:
    'Staff_Member_Edit_Confirmation_Displayed',
  STAFF_MEMBER_ADD_CONFIRMATION_DISPLAYED:
    'Staff_Member_Add_Confirmation_Displayed',
  BOOST_ACTIVATED: 'Boost_Activated',
  BOOST_REACTIVATED: 'Boost_Reactivated',
} as const

export const SEGMENT_KEYS = {
  PRODUCTION: 'sHGefKtEbbOYSxbL3CUyMVVE7gLqhVCg',
  TEST: 'M8r4Xm6RDhd1eKoZt3wK1PFihekwS5rZ',
} as const
